module.exports = __webpack_public_path__ + "img/广告图四.ca8a53b2.jpg";